/**
 * sessionStorage: pathname + search da rota interna anterior à atual.
 * Gravado por SpaPreviousRouteTracker em App.js.
 */
export const SPA_PREVIOUS_INTERNAL_PATH_KEY = 'spa_previous_internal_path';

/**
 * Volta para a rota SPA anterior (sessionStorage) ou fallback.
 * Opcional para telas que não podem usar apenas history.back().
 */
export function navigateToPreviousInternalRoute(navigate, currentFullPath, fallbackPath) {
    try {
        const prev = sessionStorage.getItem(SPA_PREVIOUS_INTERNAL_PATH_KEY);
        if (prev && prev !== currentFullPath) {
            navigate(prev);
            return;
        }
    } catch {
        /* ignore */
    }
    navigate(fallbackPath);
}
